var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrendDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M.96 5.126a1 1 0 0 1 1.414 0L6.43 9.183l.236.233.027-.026c.058-.056.124-.122.208-.207l2.281-2.28.021-.022a8 8 0 0 1 .434-.413 1.9 1.9 0 0 1 .629-.366c.368-.12.765-.12 1.133 0 .27.088.475.236.628.366.138.117.288.267.434.413l4.871 4.871V8.333a1 1 0 1 1 2 0v5.834a1 1 0 0 1-1 1H12.5a1 1 0 1 1 0-2h3.42l-4.851-4.85-.236-.233-.027.026c-.058.056-.124.123-.208.207l-2.281 2.28-.021.022a8 8 0 0 1-.434.413 1.9 1.9 0 0 1-.629.367c-.368.12-.765.12-1.133 0a1.9 1.9 0 0 1-.628-.367 8 8 0 0 1-.434-.413l-.021-.021L.96 6.54a1 1 0 0 1 0-1.414",
  clipRule: "evenodd"
})));
SvgTrendDown.displayName = "SvgTrendDown";
export { SvgTrendDown as ReactComponent };
export default SvgTrendDown;